import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import InlineSVG from 'svg-inline-react';
import classNames from 'classnames';
import searchIcon from 'app/assets/new-design/images/icons/search.svg';
import useI18n from 'hooks/I18n/useI18n';
import { AssembliesMapModalNavContext } from 'components/Maps/ProductIdentity/AssembliesMap/AssembliesMapModalNavigactionContext.jsx';
import { PRIMARY_FILTERS } from '../assembliesMapReducer.js';
import Autocomplete from 'src/components/molecules/Autocomplete/Autocomplete.jsx';
import AssembliesMapFilters from './AssembliesMapFilters.jsx';
import { SMALL_SIZE } from 'src/components/atoms/Input/Input.jsx';
import useResponsive from 'hooks/Navigation/useResponsive';
import MapSwitch from '../../../../../src/components/atoms/MapSwitch/MapSwitch.jsx';

export const AssembliesMapFiltersBar = ({
    selectedPrimaryFilter,
    onChangePrimaryFilter,
    onToggleOnlyOpenSaleFilter,
    onAutocompleteChange,
    onAutocompleteBlur,
    onSuggestionClick,
    isOnlyOpenSaleFilterEnabled,
    children,
    autocompleteRef,
    autocompleteSuggestions = [],
    opened = false,
    isMapChecked,
    onToggleMapSwitch,
}) => {
    const { trans } = useI18n();
    const [shouldOpen, setShouldOpen] = useState(false);
    const { showNearbyAssemblies } = useContext(AssembliesMapModalNavContext);
    const isTabletOrMobile = useResponsive(991);

    const handleMapSwitchChange = e => {
        onToggleMapSwitch(e.target.checked);
    };

    useEffect(() => {
        setShouldOpen(opened && isMapChecked);
    }, [opened, isMapChecked]);

    const searchSVG = <InlineSVG className="map-search-icon" src={searchIcon} />;

    return (
        <div className="map-filters-flex-container">
            <div className={classNames('map-filters-grid', { 'filter-fixed': !isMapChecked })}>
                <div className="map-filters-scrollable-container">
                    {!showNearbyAssemblies &&
                        (isTabletOrMobile ? (
                            <>
                                <div className="map-filters-scrollable-container-search-container">
                                    <Autocomplete
                                        ref={autocompleteRef}
                                        placeholder={trans(
                                            'assembliesMap.autocomplete.placeholder'
                                        )}
                                        prefix={searchSVG}
                                        onChange={onAutocompleteChange}
                                        onBlur={onAutocompleteBlur}
                                        onItemClick={onSuggestionClick}
                                        suggestions={autocompleteSuggestions}
                                        size={SMALL_SIZE}
                                    />
                                    <MapSwitch
                                        checked={isMapChecked}
                                        onChange={handleMapSwitchChange}
                                    />
                                </div>
                                <div className="map-filters-bar">
                                    <AssembliesMapFilters
                                        isOnlyOpenSaleFilterEnabled={isOnlyOpenSaleFilterEnabled}
                                        onToggleOnlyOpenSaleFilter={onToggleOnlyOpenSaleFilter}
                                        onChangePrimaryFilter={onChangePrimaryFilter}
                                        selectedPrimaryFilter={selectedPrimaryFilter}
                                    />
                                </div>

                                {shouldOpen && (
                                    <div className="map-assembly-block open">{children}</div>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="map-filters-open-sale">
                                    <AssembliesMapFilters
                                        isOnlyOpenSaleFilterEnabled={isOnlyOpenSaleFilterEnabled}
                                        onToggleOnlyOpenSaleFilter={onToggleOnlyOpenSaleFilter}
                                        onChangePrimaryFilter={onChangePrimaryFilter}
                                        selectedPrimaryFilter={selectedPrimaryFilter}
                                    />
                                    <div className="map-filters-open-sale-input">
                                        <Autocomplete
                                            ref={autocompleteRef}
                                            placeholder={trans(
                                                'assembliesMap.autocomplete.placeholder'
                                            )}
                                            prefix={searchSVG}
                                            onChange={onAutocompleteChange}
                                            onBlur={onAutocompleteBlur}
                                            onItemClick={onSuggestionClick}
                                            suggestions={autocompleteSuggestions}
                                            size={SMALL_SIZE}
                                        />
                                    </div>
                                </div>
                                <div className={classNames('map-assembly-block', { open: opened })}>
                                    {children}
                                </div>
                            </>
                        ))}
                </div>
            </div>
        </div>
    );
};

AssembliesMapFiltersBar.propTypes = {
    children: PropTypes.node,
    opened: PropTypes.bool,
    selectedPrimaryFilter: PropTypes.oneOf(PRIMARY_FILTERS).isRequired,
    onChangePrimaryFilter: PropTypes.func.isRequired,
    onToggleOnlyOpenSaleFilter: PropTypes.func.isRequired,
    onAutocompleteChange: PropTypes.func.isRequired,
    onAutocompleteBlur: PropTypes.func.isRequired,
    onSuggestionClick: PropTypes.func.isRequired,
    isOnlyOpenSaleFilterEnabled: PropTypes.bool.isRequired,
    autocompleteRef: PropTypes.object.isRequired,
    autocompleteSuggestions: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            metadata: PropTypes.shape({
                geoloc: PropTypes.shape({
                    lat: PropTypes.number.isRequired,
                    lng: PropTypes.number.isRequired,
                }).isRequired,
            }).isRequired,
        })
    ).isRequired,
    isMapChecked: PropTypes.bool,
    onToggleMapSwitch: PropTypes.func,
};

export default AssembliesMapFiltersBar;
